import { toast as sonnerToast } from 'sonner';
import { ApiError } from './api-error';

// Wrapper thin sobre sonner. Encapsula la API + permite cambiar de lib en
// el futuro sin tocar consumers. `apiError` extrae el message de ApiError /
// Error y lo presenta como description.

interface ToastOptions {
  description?: string;
  id?: string | number;
}

export const toast = {
  success(message: string, opts?: ToastOptions): void {
    sonnerToast.success(message, opts);
  },
  error(message: string, opts?: ToastOptions): void {
    sonnerToast.error(message, opts);
  },
  info(message: string, opts?: ToastOptions): void {
    sonnerToast(message, opts);
  },
  warning(message: string, opts?: ToastOptions): void {
    sonnerToast.warning(message, opts);
  },
  // Helper específico para mutations: toma el prefix ("No se pudo crear...")
  // y deriva el description del ApiError/Error si tiene message.
  apiError(prefix: string, err: unknown): void {
    if (err instanceof ApiError) {
      sonnerToast.error(prefix, { description: err.message });
      return;
    }
    if (err instanceof Error && err.message.length > 0) {
      sonnerToast.error(prefix, { description: err.message });
      return;
    }
    sonnerToast.error(prefix);
  },
};
